export default __webpack_public_path__ + "static/media/website.1e2f6a5e.svg";